"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABICoder = exports.FunctionCall = void 0;
var utils_1 = require("./utils");
var contract_1 = require("./contract");
var scryptTypes_1 = require("./scryptTypes");
var compilerWrapper_1 = require("./compilerWrapper");
var FunctionCall = /** @class */ (function () {
    function FunctionCall(methodName, binding) {
        this.methodName = methodName;
        this.args = [];
        if (binding.lockingScript === undefined && binding.unlockingScript === undefined) {
            throw new Error('param binding.lockingScript & binding.unlockingScript cannot both be empty');
        }
        this.contract = binding.contract;
        this.args = binding.args;
        if (binding.lockingScript) {
            this._lockingScript = binding.lockingScript;
        }
        if (binding.unlockingScript) {
            this._unlockingScript = binding.unlockingScript;
        }
    }
    Object.defineProperty(FunctionCall.prototype, "unlockingScript", {
        get: function () {
            return this._unlockingScript;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FunctionCall.prototype, "lockingScript", {
        get: function () {
            return this._lockingScript;
        },
        set: function (s) {
            this._lockingScript = s;
        },
        enumerable: false,
        configurable: true
    });
    FunctionCall.prototype.toASM = function () {
        return this.toScript().toASM();
    };
    FunctionCall.prototype.toString = function () {
        return this.toHex();
    };
    FunctionCall.prototype.toScript = function () {
        if (this.lockingScript) {
            return this.lockingScript;
        }
        else {
            return this.unlockingScript;
        }
    };
    FunctionCall.prototype.toHex = function () {
        return this.toScript().toHex();
    };
    FunctionCall.prototype.genLaunchConfig = function (txContext) {
        var constructorArgs = this.contract.ctorArgs().map(function (p) { return p.value; });
        var pubFuncArgs = this.args.map(function (arg) { return arg.value; });
        var pubFunc = this.methodName;
        var name = "Debug " + this.contract.contractName;
        var program = "" + this.contract.file;
        var asmArgs = this.contract.asmArgs || {};
        var state = !contract_1.AbstractContract.isStateful(this.contract) && this.contract.dataPart ? this.contract.dataPart.toASM() : undefined;
        var txCtx = Object.assign({}, this.contract.txContext || {}, txContext || {}, { opReturn: state });
        if (contract_1.AbstractContract.isStateful(this.contract)) {
            Object.assign(txCtx, { opReturnHex: this.contract.dataPart.toHex() });
        }
        else if (this.contract.dataPart) {
            Object.assign(txCtx, { opReturn: this.contract.dataPart.toASM() });
        }
        return utils_1.genLaunchConfigFile(constructorArgs, pubFuncArgs, pubFunc, name, program, txCtx, asmArgs);
    };
    FunctionCall.prototype.verify = function (txContext) {
        var result = this.contract.run_verify(this.unlockingScript.toASM() || '', txContext);
        if (!result.success) {
            var debugUrl = this.genLaunchConfig(txContext);
            if (debugUrl) {
                result.error = result.error + ("\t[Launch Debugger](" + debugUrl.replace(/file:/i, 'scryptlaunch:') + ")\n");
            }
        }
        return result;
    };
    return FunctionCall;
}());
exports.FunctionCall = FunctionCall;
var ABICoder = /** @class */ (function () {
    function ABICoder(abi, resolver) {
        this.abi = abi;
        this.resolver = resolver;
    }
    ABICoder.prototype.checkArgs = function (contractname, funname, params) {
        var _this = this;
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        if (args.length !== params.length) {
            throw new Error("wrong number of arguments for '" + contractname + "." + funname + "', expected " + params.length + " but got " + args.length);
        }
        params.forEach(function (param, index) {
            var arg = args[index];
            var error = utils_1.checkSupportedParamType(arg, param, _this.resolver.resolverType);
            if (error)
                throw error;
        });
    };
    ABICoder.prototype.encodeConstructorCall = function (contract, hexTemplate) {
        var _this = this;
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var constructorABI = this.abi.filter(function (entity) { return entity.type === compilerWrapper_1.ABIEntityType.CONSTRUCTOR; })[0];
        var cParams = (constructorABI === null || constructorABI === void 0 ? void 0 : constructorABI.params) || [];
        this.checkArgs.apply(this, __spread([contract.contractName, 'constructor', cParams], args));
        // handle array type
        var flatteredArgs = utils_1.flatternCtorArgs(cParams.map(function (p, index) {
            return Object.assign(__assign({}, p), {
                value: args[index],
            });
        }), this.resolver.resolverType);
        flatteredArgs.forEach(function (arg) {
            if (!hexTemplate.includes("<" + arg.name + ">")) {
                throw new Error("abi constructor params mismatch with args provided: missing " + arg.name + " in ASM tempalte");
            }
            contract.hexTemplateArgs.set("<" + arg.name + ">", _this.encodeParam(arg.value, arg));
        });
        contract.hexTemplateArgs.set('<__codePart__>', '00');
        contract.statePropsArgs = utils_1.buildDefaultStateProps(contract);
        var lockingScript = utils_1.buildContractCode(contract.hexTemplateArgs, contract.hexTemplateInlineASM, hexTemplate);
        return new FunctionCall('constructor', {
            contract: contract,
            lockingScript: lockingScript,
            args: cParams.map(function (param, index) { return ({
                name: param.name,
                type: param.type,
                value: args[index],
            }); }),
        });
    };
    ABICoder.prototype.encodeConstructorCallFromRawHex = function (contract, hexTemplate, raw) {
        var script = utils_1.mvc.Script.fromHex(raw);
        var constructorABI = this.abi.filter(function (entity) { return entity.type === compilerWrapper_1.ABIEntityType.CONSTRUCTOR; })[0];
        var cParams = (constructorABI === null || constructorABI === void 0 ? void 0 : constructorABI.params) || [];
        var offset = 0;
        var dataPartInHex = undefined;
        for (var index = 0; index < script.chunks.length; index++) {
            var chunk = script.chunks[index];
            if (offset >= hexTemplate.length && chunk.opcodenum == 106 /*OP_RETURN*/) {
                var b = utils_1.mvc.Script.fromChunks(script.chunks.slice(index + 1));
                dataPartInHex = b.toHex();
                break;
            }
            else if (hexTemplate.charAt(offset) == '<') {
                var start = offset;
                var found = false;
                while (!found && offset < hexTemplate.length) {
                    offset++;
                    if (hexTemplate.charAt(offset) == '>') {
                        offset++;
                        found = true;
                    }
                }
                if (!found) {
                    throw new Error('cannot found break >');
                }
                var name_1 = hexTemplate.substring(start, offset);
                var bw = new utils_1.mvc.encoding.BufferWriter();
                bw.writeUInt8(chunk.opcodenum);
                if (chunk.buf) {
                    if (chunk.opcodenum < utils_1.mvc.Opcode.OP_PUSHDATA1) {
                        bw.write(chunk.buf);
                    }
                    else if (chunk.opcodenum === utils_1.mvc.Opcode.OP_PUSHDATA1) {
                        bw.writeUInt8(chunk.len);
                        bw.write(chunk.buf);
                    }
                    else if (chunk.opcodenum === utils_1.mvc.Opcode.OP_PUSHDATA2) {
                        bw.writeUInt16LE(chunk.len);
                        bw.write(chunk.buf);
                    }
                    else if (chunk.opcodenum === utils_1.mvc.Opcode.OP_PUSHDATA4) {
                        bw.writeUInt32LE(chunk.len);
                        bw.write(chunk.buf);
                    }
                }
                if (name_1.startsWith("<" + contract.contractName + ".")) {
                    //inline asm
                    contract.hexTemplateInlineASM.set(name_1, bw.toBuffer().toString('hex'));
                }
                else {
                    contract.hexTemplateArgs.set(name_1, bw.toBuffer().toString('hex'));
                }
            }
            else {
                var op = hexTemplate.substring(offset, offset + 2);
                offset = offset + 2;
                if (parseInt(op, 16) != chunk.opcodenum) {
                    throw new Error("the raw script cannot match the ASM template of contract " + contract.contractName);
                }
                if (chunk.len > 0) {
                    var data = hexTemplate.substring(offset, offset + chunk.len * 2);
                    if (chunk.buf.toString('hex') != data) {
                        throw new Error("the raw script cannot match the ASM template of contract " + contract.contractName);
                    }
                    offset = offset + chunk.len * 2;
                }
            }
        }
        var ctorArgs = cParams.map(function (param) {
            return utils_1.deserializeArgfromHex(contract.resolver, Object.assign(param, {
                value: undefined,
            }), contract.hexTemplateArgs);
        });
        if (contract_1.AbstractContract.isStateful(contract)) {
            var scriptHex = dataPartInHex;
            var metaScript = dataPartInHex.substr(scriptHex.length - 10, 10);
            var version = utils_1.bin2num(metaScript.substr(metaScript.length - 2, 2));
            switch (version) {
                case 0:
                    {
                        var _a = __read(utils_1.parseStateHex(contract, scriptHex), 2), firstCall = _a[0], args = _a[1];
                        contract.statePropsArgs = args;
                        contract.firstCall = firstCall;
                    }
                    break;
            }
        }
        else if (dataPartInHex) {
            contract.setDataPartInHex(dataPartInHex);
        }
        return new FunctionCall('constructor', { contract: contract, lockingScript: script, args: ctorArgs });
    };
    ABICoder.prototype.encodePubFunctionCall = function (contract, name, args) {
        var e_1, _a;
        var _this = this;
        try {
            for (var _b = __values(this.abi), _c = _b.next(); !_c.done; _c = _b.next()) {
                var entity = _c.value;
                if (entity.name === name) {
                    this.checkArgs.apply(this, __spread([contract.contractName, name, entity.params], args));
                    var hex = this.encodeParams(args, entity.params.map(function (p) { return ({
                        name: p.name,
                        type: _this.resolver.resolverType(p.type).finalType,
                    }); }));
                    if (this.abi.length > 2 && entity.index !== undefined) {
                        // selector when there are multiple public functions
                        var pubFuncIndex = entity.index;
                        hex += "" + utils_1.mvc.Script.fromASM(utils_1.int2Asm(pubFuncIndex.toString())).toHex();
                    }
                    return new FunctionCall(name, {
                        contract: contract,
                        unlockingScript: utils_1.mvc.Script.fromHex(hex),
                        args: entity.params.map(function (param, index) { return ({
                            name: param.name,
                            type: param.type,
                            value: args[index],
                        }); }),
                    });
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        throw new Error("no public function named '" + name + "' found in contract '" + contract.contractName + "'");
    };
    /**
     * build a FunctionCall by function name and unlocking script in hex.
     * @param contract
     * @param name name of public function
     * @param hex hex of unlocking script
     * @returns a FunctionCall which contains the function parameters that have been deserialized
     */
    ABICoder.prototype.encodePubFunctionCallFromHex = function (contract, name, hex) {
        var script = utils_1.mvc.Script.fromHex(hex);
        var entity = this.abi.filter(function (entity) { return entity.type === 'function' && entity.name === name; })[0];
        if (!entity) {
            throw new Error("no public function named '" + name + "' found in contract '" + contract.contractName + "'");
        }
        var cParams = (entity === null || entity === void 0 ? void 0 : entity.params) || [];
        var flatternArgs = utils_1.flatternParams(cParams, contract.resolver);
        var fArgsLen = flatternArgs.length;
        if (this.abi.length > 2 && entity.index !== undefined) {
            fArgsLen += 1;
        }
        var usASM = script.toASM();
        var asmOpcodes = usASM.split(' ');
        if (fArgsLen != asmOpcodes.length) {
            throw new Error("the raw unlockingScript cannot match the arguments of public function " + name + " of contract " + contract.contractName);
        }
        var hexTemplateArgs = new Map();
        flatternArgs.forEach(function (farg, index) {
            hexTemplateArgs.set("<" + farg.name + ">", utils_1.mvc.Script.fromASM(asmOpcodes[index]).toHex());
        });
        var args = cParams.map(function (param) {
            return utils_1.deserializeArgfromHex(contract.resolver, Object.assign(param, {
                value: undefined,
            }), hexTemplateArgs);
        });
        return new FunctionCall(name, { contract: contract, unlockingScript: script, args: args });
    };
    ABICoder.prototype.encodeParams = function (args, paramsEntitys) {
        var _this = this;
        return args.map(function (arg, i) { return _this.encodeParam(arg, paramsEntitys[i]); }).join('');
    };
    ABICoder.prototype.encodeParamArray = function (args, arrayParam) {
        var _this = this;
        return utils_1.flatternArray(args, arrayParam.name, arrayParam.type)
            .map(function (arg) {
            return _this.encodeParam(arg.value, { name: arg.name, type: _this.resolver.resolverType(arg.type).finalType });
        })
            .join('');
    };
    ABICoder.prototype.encodeParam = function (arg, paramEntity) {
        if (utils_1.isArrayType(paramEntity.type)) {
            return this.encodeParamArray(arg, paramEntity);
        }
        if (arg instanceof scryptTypes_1.ScryptType) {
            return arg.toHex();
        }
        var typeofArg = typeof arg;
        if (typeofArg === 'boolean') {
            arg = new scryptTypes_1.Bool(arg);
        }
        else if (typeofArg === 'number') {
            arg = new scryptTypes_1.Int(arg);
        }
        else if (typeofArg === 'bigint') {
            arg = new scryptTypes_1.Int(arg);
        }
        else if (typeof arg === 'string') {
            arg = new scryptTypes_1.Int(arg);
        }
        else {
            //we call checkArg before encodeParam, shouldn't get here under normal circumstances
            throw new Error("The value of parameter " + paramEntity.name + " is unknown type: " + typeofArg);
        }
        return arg.toHex();
    };
    return ABICoder;
}());
exports.ABICoder = ABICoder;
//# sourceMappingURL=abi.js.map